import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE,
} from '../actions/actionTypes';
import { getEquityCategoryAndBrandsDataService } from '../../services';
import { getEquityCategoryAndBrandsApiEndpoint } from '../../services/endpoints';
import { updateIsAllTerritoryId } from 'src/utils/util';

export default function* getEquityCategoryAndBrands() {
    let territoryIdValue;
    try {
        const { territoryId } = yield select((state) => ({
            territoryId: state.equityReducer.equityDetails.territoryId
        }));
        territoryIdValue =  updateIsAllTerritoryId(territoryId);
        const result = yield getEquityCategoryAndBrandsDataService(encodeURIComponent(territoryIdValue));
        const updatedData = result?.brandData?.map((item) => {
            return {
                ...item,
                isChecked: false,
            };
        });
        result.brandData = updatedData;
        yield put({
            type: GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS,
            categoryAndBrands: result,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: getEquityCategoryAndBrandsApiEndpoint(encodeURIComponent(territoryIdValue)),
            requestPayload: { territoryId: encodeURIComponent(territoryIdValue) }
        });
        yield put({
            type: GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
